"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CATEGORIES = exports.MORE_OPTIONS_CATEGORIES = exports.THREAT_CATEGORIES = exports.HARRASSMENT_CATEGORIES = exports.NUDITY_CATEGORIES = exports.ReportCategoryId = exports.DELAY_AFTER_SUBMIT = exports.REPORT_SUBMITTED_CLOSE_MESSAGE = exports.REPORT_SUBMITTED_MESSAGE = exports.REPORT_SUBMITTED_HEADER = exports.CLOSE_BUTTON = exports.CANCEL_BUTTON = exports.SUBMIT_BUTTON = exports.TEXTFIELD_TITLE = exports.REPORT_SUBTEXT = exports.REPORT_SNAP = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const COPYRIGHT_REPORTING_LINK = "https://help.snapchat.com/hc/requests/new?co=true&ticket_form_id=71659";
exports.REPORT_SNAP = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "8Sw4jY", description: "Title of modal for reporting a snap", defaultMessage: "Report Snap" }));
exports.REPORT_SUBTEXT = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "sRM8i5", description: "Subtitle asking users for report category", defaultMessage: "Why do you want to report this Snap?" }));
exports.TEXTFIELD_TITLE = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "jqpH+5", description: "Title above textbox where more information about snap to be reported can be written", defaultMessage: "Is there any more information you want to share about this Snap?" }));
exports.SUBMIT_BUTTON = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "ESomE8", description: "Submit report", defaultMessage: "Submit" }));
exports.CANCEL_BUTTON = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "PyzdXL", description: "Cancel reporting snap", defaultMessage: "Cancel" }));
exports.CLOSE_BUTTON = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "2LLiYb", description: "Close reporting snap", defaultMessage: "Close" }));
exports.REPORT_SUBMITTED_HEADER = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "VRmDFV", description: "Header shown after a report has been submitted", defaultMessage: "Snap Reported" }));
exports.REPORT_SUBMITTED_MESSAGE = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "ATeDiR", description: "Copy shown afer a report has been submitted", defaultMessage: "Thank you for reporting this Snap." }));
exports.REPORT_SUBMITTED_CLOSE_MESSAGE = ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "04qzmG", description: "Message relaying close prompt after report has been submitted", defaultMessage: "You will now be taken to the next Snap - press 'Close' to do this right away or we will continue automatically in 10 seconds." }));
exports.DELAY_AFTER_SUBMIT = 10000;
var ReportCategoryId;
(function (ReportCategoryId) {
    ReportCategoryId["HARASSMENT"] = "harassment";
    ReportCategoryId["HURT"] = "hurt";
    ReportCategoryId["JUST_DONT_LIKE"] = "just_dont_like";
    ReportCategoryId["NUDITY"] = "nudity";
    ReportCategoryId["THREAT"] = "threat";
    ReportCategoryId["PRETENDING"] = "report_snap_story_reason_they_are_pretending_to_be_me";
    // FIXME: when this option is selected, send user to copyright infringement page
    // https://jira.sc-corp.net/browse/WEB-662
    ReportCategoryId["COPYRIGHT"] = "copyright";
    ReportCategoryId["SOMETHING_ELSE"] = "something_else";
    ReportCategoryId["SNAP_OF_ME"] = "report_snap_story_reason_its_an_inappropriate_snap_of_me";
    ReportCategoryId["SNAP_OF_SOMEONE_ELSE"] = "report_snap_story_reason_its_an_inappropriate_snap_of_someone_else";
    ReportCategoryId["THREAT_TO_POST"] = "report_snap_story_reason_it_asks_for_or_threatens_to_post_inappropriate_snaps";
    ReportCategoryId["SELL_SNAPS"] = "report_snap_story_reason_it_sells_or_promotes_inappropriate_snaps";
    ReportCategoryId["BULLYING_ME"] = "report_snap_story_reason_i_am_being_bullied_or_harassed";
    ReportCategoryId["BULLYING_SOMEONE_ELSE"] = "report_snap_story_reason_someone_else_is_being_bullied_or_harassed";
    ReportCategoryId["PRIVACY"] = "report_snap_story_reason_it_invades_my_privacy";
    ReportCategoryId["HATE_SPEECH"] = "report_snap_story_reason_hate_speech_targeting_an_individual_or_group";
    ReportCategoryId["THREATENING_PERSON_PLACE"] = "report_snap_story_reason_threat_involving_a_specific_person_time_or_place";
    ReportCategoryId["VIOLENT"] = "report_snap_story_reason_violent_or_disturbing_content";
    ReportCategoryId["MORE_OPTIONS"] = "more_options";
    ReportCategoryId["WORRIED"] = "report_snap_story_reason_self_injury_or_suicide";
    ReportCategoryId["DRUGS_OR_WEAPONS"] = "report_snap_story_reason_buying_or_selling_drugs_or_other_regulated_goods";
    ReportCategoryId["SPAM"] = "report_snap_story_reason_its_spam";
})(ReportCategoryId = exports.ReportCategoryId || (exports.ReportCategoryId = {}));
// This is an example of a sub category that opens from a top level category
exports.NUDITY_CATEGORIES = new Map([
    [
        ReportCategoryId.SNAP_OF_ME,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "rNVPnk", description: "Report category for a snap with inappropriate content of the user", defaultMessage: "It's an inappropriate Snap of me" })),
        },
    ],
    [
        ReportCategoryId.SNAP_OF_SOMEONE_ELSE,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "Gvuqme", description: "Report category for a snap with inappropriate content of somebody else", defaultMessage: "It's an inappropriate Snap of someone else" })),
        },
    ],
    [
        ReportCategoryId.THREAT_TO_POST,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "1PzCdm", description: "Report category for a snap which is threatening to post inappropriate snaps", defaultMessage: "It asks for or threatens to post inappropriate Snaps" })),
        },
    ],
    [
        ReportCategoryId.SELL_SNAPS,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "HLxWNM", description: "Report category for a snap which sells or promotes inappropriate snaps", defaultMessage: "It sells or promotes inappropriate Snaps" })),
        },
    ],
]);
// This is an example of a sub category that opens from a top level category
exports.HARRASSMENT_CATEGORIES = new Map([
    [
        ReportCategoryId.BULLYING_ME,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "vTd+a8", description: "Report category for a snap which is bullying or harassing the user", defaultMessage: "I'm being bullied or harassed" })),
        },
    ],
    [
        ReportCategoryId.BULLYING_SOMEONE_ELSE,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "FDOu63", description: "Report category for a snap which is bullying or harassing something else", defaultMessage: "Someone else is being bullied or harassed" })),
        },
    ],
    [
        ReportCategoryId.PRIVACY,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "AbkQPs", description: "Report category for a snap which is an invasion of privacy", defaultMessage: "It's an invasion of privacy" })),
        },
    ],
    [
        ReportCategoryId.HATE_SPEECH,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "lbui+i", description: "Report category for a snap which includes hate speech", defaultMessage: "It's hate speech targeting me or another group" })),
        },
    ],
]);
exports.THREAT_CATEGORIES = new Map([
    [
        ReportCategoryId.THREATENING_PERSON_PLACE,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "Ftta6c", description: "Report category for a snap which is threatening a person or place", defaultMessage: "It's threatening a person or place" })),
        },
    ],
    [
        ReportCategoryId.VIOLENT,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "N7Wq/c", description: "Report category for a snap which is violent or disturbing", defaultMessage: "Violent or disturbing" })),
        },
    ],
]);
exports.MORE_OPTIONS_CATEGORIES = new Map([
    [
        ReportCategoryId.WORRIED,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "5m3Hu8", description: "Report category for a snap which makes the user worried the snapchatter may hurt themselves", defaultMessage: "I'm worried this Snapchatter might hurt themselves" })),
        },
    ],
    [
        ReportCategoryId.DRUGS_OR_WEAPONS,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "UIZTzu", description: "Report category for a snap which attempts to buy or sell drugs or weapons", defaultMessage: "It's attempting to buy or sell drugs or weapons" })),
        },
    ],
    [
        ReportCategoryId.SPAM,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "GJZs5E", description: "Report category for a snap which is spam", defaultMessage: "It's spam" })),
        },
    ],
]);
/*
 * This config lays out the default, top level reporting categories
 * To add a new category to report,
 * - create a ReportCategoryId
 * - add it to the default categories here
 * - if you want to make a category open a set of sub categories, create a new map of
 *   report category and add it to 'subCategory'
 */
exports.DEFAULT_CATEGORIES = new Map([
    [
        ReportCategoryId.JUST_DONT_LIKE,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "5HsSrO", description: "Report category for a snap which the user doesn't like", defaultMessage: "I just don't like it" })),
        },
    ],
    [
        ReportCategoryId.NUDITY,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "CAgCZ5", description: "Report category for a snap which contains nudity or sexual content", defaultMessage: "Nudity or sexual content" })),
            subCategory: exports.NUDITY_CATEGORIES,
        },
    ],
    [
        ReportCategoryId.HARASSMENT,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "RJo0Z3", description: "Report category for a snap which contains harassment or hate speech", defaultMessage: "Harassment or Hate speech" })),
            subCategory: exports.HARRASSMENT_CATEGORIES, // Make a category open a set of sub categories
        },
    ],
    [
        ReportCategoryId.THREAT,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "0dJz6S", description: "Report category for a snap which contains threats or violence", defaultMessage: "Threatening, violent, or concerning" })),
            subCategory: exports.THREAT_CATEGORIES,
        },
    ],
    [
        ReportCategoryId.PRETENDING,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "WyUwHm", description: "Report category for a snap where the snapchatter is pretending to be the user", defaultMessage: "They are pretending to be me" })),
        },
    ],
    [
        ReportCategoryId.COPYRIGHT,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "+lhElX", description: "Report category for a snap containing copyright infringement", defaultMessage: "Copyright infringement" })),
            reportLink: COPYRIGHT_REPORTING_LINK,
        },
    ],
    [
        ReportCategoryId.MORE_OPTIONS,
        {
            text: ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "2V40yT", description: "More report categories", defaultMessage: "More Options" })),
            subCategory: exports.MORE_OPTIONS_CATEGORIES,
        },
    ],
]);
//# sourceMappingURL=constants.js.map